import { SvgIconProps } from "@mui/material";
import React, { FC } from "react";

const Logo: FC<SvgIconProps> = (props) => {
  return (
    <svg
      id="Markenzeichen"
      viewBox="0 0 79.370002 71.30088"
      version="1.1"
      width="79.370003"
      height="71.30088"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs id="defs35" />
      <title id="title2">TÜV Rheinland</title>
      <path
        d="M 74,59.41 A 85,85 0 0 0 59.55,58.16 79.15,79.15 0 0 0 39.7,60.64 78.43,78.43 0 0 1 19.87,63.17 70,70 0 0 1 12.72,62.82 l 27,-46.7 L 56,44.29 A 78.76,78.76 0 0 0 39.69,46.7 77.34,77.34 0 0 1 27.91,48.77 L 23,57.28 a 82.43,82.43 0 0 0 16.69,-2.43 79.07,79.07 0 0 1 19.84,-2.49 82.09,82.09 0 0 1 10.8,0.71 L 65.16,44.13 51.81,21 39.69,0 0,68.73 a 75.14,75.14 0 0 0 19.85,2.57 75.06,75.06 0 0 0 19.84,-2.57 80.92,80.92 0 0 1 39.68,0 z"
        id="path30"
      />
    </svg>
  );
};

export default Logo;
